import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onCreateNew, hasFilters, onResetFilters }) => {
  if (hasFilters) {
    return (
      <div className="bg-card border border-border rounded-xl p-8 md:p-12 text-center">
        <div className="max-w-md mx-auto">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Search" size={32} className="text-muted-foreground" />
          </div>
          
          <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground mb-2">
            검색 결과가 없습니다
          </h3>
          
          <p className="text-sm md:text-base caption text-muted-foreground mb-6">
            다른 검색 조건으로 다시 시도해보세요
          </p>
          
          <Button
            variant="outline"
            size="default"
            iconName="RotateCcw"
            iconPosition="left"
            onClick={onResetFilters}
          >
            필터 초기화
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-xl p-8 md:p-12 text-center">
      <div className="max-w-md mx-auto">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="Calendar" size={32} color="var(--color-primary)" />
        </div>
        
        <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground mb-2">
          아직 생성된 세션이 없습니다
        </h3>
        
        <p className="text-sm md:text-base caption text-muted-foreground mb-6">
          첫 번째 세션을 만들어 참가자 관리를 시작하세요
        </p>
        
        <Button
          variant="default"
          size="lg"
          iconName="Plus"
          iconPosition="left"
          onClick={onCreateNew}
        >
          새 세션 만들기
        </Button>
      </div>
    </div>
  );
};

export default EmptyState;